module.exports = __webpack_public_path__ + "img/star1.80f02b7d.png";